module.exports = __webpack_public_path__ + "static/media/sports.004b253a.jpeg";